define('adminKitprView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!adminKitprListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var KitprListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'kitprListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteKitpr: '.delete-kitpr-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteKitpr': 'onDeleteKitpr'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {
                type: 'kitpr',
                data: this.options.data
            };
            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteKitpr: function(event){
            this.trigger('kitpr:delete', this.options.data.model.get('secId'), $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('kitpr.refMbAModel'),
                        name: 'refMbAModel.code',
                        classes: 'kitpr-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'refMbAModel.code'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-kitpr-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {                    
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            App.navigate('admin/kitpr' + '/' + rowId + '/detail', {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = KitprListView;
});
